// src/App.js
import React, { useState, useEffect } from 'react';
import { TextField, Button, Snackbar, Alert, MenuItem, Select, FormControl, InputLabel, CircularProgress, Typography, Grid, Paper, Box, Divider } from '@mui/material';
import StudentTable from './StudentTable';
import { canteenService } from '../services/canteenService';

import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { login } from '../redux/admin';
import { loin, logout, updatestudentdata, getdata, updateCanteenPayments } from '../redux/students';
import { getdata_ } from '../redux/class';
import { schooldetails } from '../redux/schooldetails';
import { getCurrencySymbolFromSchool } from '../utils/currencyFormatter';


const initialStudents = [
  { id: 1, name: 'John Doe', amount: '', date: '2024-11-01', class: 'Math', paymentStatus: 'Pending' },
  { id: 2, name: 'Jane Smith', amount: '', date: '2024-11-02', class: 'Science', paymentStatus: 'Pending' },
  { id: 3, name: 'Sam Johnson', amount: '', date: '2024-11-03', class: 'History', paymentStatus: 'Pending' },
  { id: 4, name: 'Alex Lee', amount: '', date: '2024-11-01', class: 'Math', paymentStatus: 'Pending' },
  { id: 5, name: 'Emily Davis', amount: '', date: '2024-11-03', class: 'Science', paymentStatus: 'Pending' },
];

const getCurrentDate = () => {
  const today = new Date();
  return today.toISOString().split('T')[0];
};

function createData(_id,id,lastname,othernames,status,image, class_, gender, dob,hometown,residence, religion, motherlastname, motherothernames, motheroccupation, mothercontact, motheremail, motherresidence, fatherlastname,fatherothernames, fatheroccupation, fathercontact, fatheremail, fatherresidence, guardianlastname,guardianothernames, guardianoccupation, guardiancontact, guardianemail, guardianresidence, guardianrelationship,  academic ,finance, attendance, Awards, behaviour, others, dailycharge, index, specialID, nextclass, housing) 
{
    return {
        _id,
        id,
        lastname,
        othernames,
        status,
        image,
        class_,
        gender,
        dob,
        hometown,
        residence,
        religion,
        motherlastname,
        motherothernames,
        motheroccupation,
        mothercontact,
        motheremail,
        motherresidence,
        fatherlastname,
        fatherothernames,
        fatheroccupation,
        fathercontact,
        fatheremail,
        fatherresidence, 
        guardianlastname,
        guardianothernames,
        guardianoccupation,
        guardiancontact,
        guardianemail,
        guardianresidence,
        guardianrelationship,
        academic,
        finance,
        attendance,
        Awards,
        behaviour,
        others,
        dailycharge,
        index,
        specialID,
        nextclass,
        housing, 
        
    };
}

function App() {
  const [selected, setSelected] = useState([]);
  const [inputAmount, setInputAmount] = useState('');
  const [filter, setFilter] = useState('');
  const [selectedClass, setSelectedClass] = useState('');
  const [selectedDate, setSelectedDate] = useState(getCurrentDate());
  const [openAlert, setOpenAlert] = useState(false);
  const [message, setmessage] = useState("");
  const [stated, setstated] = useState("");
  const [loading, setloading] = useState(false);
  const [opensnack, setOpensnack] = useState(false);
  const [canteenStatus, setCanteenStatus] = useState(null);
  const [setupLoading, setSetupLoading] = useState(false);
  const [studentAmounts, setStudentAmounts] = useState({}); // Store individual student amounts

  // Redux selectors
  const dispatch = useDispatch();
  const admin = useSelector((state) => state.admin);
  const studentsFromRedux = useSelector((state) => state.students);
  const schooldetails_ = useSelector((state) => state.schooldetails);
  const Class_ = useSelector((state) => state.class) || [];
  
  // Get currency symbol from school details
  const currencySymbol = getCurrencySymbolFromSchool(schooldetails_ || []);
  
  // Get the actual schooldetails object (it's an array)
  const schooldetails = schooldetails_?.length > 0 ? schooldetails_[0] : null;
  
  // Filter students based on class if needed
  const students = admin?.class_ === undefined ? 
    studentsFromRedux : 
    admin?.class_?.length !== 0 ? 
      studentsFromRedux.filter(student => admin.class_[0].includes(student.class_)) :
      studentsFromRedux.filter(student => student.class_ === admin.positiondescription_);



  // Load initial data when component mounts
  useEffect(() => {
    const loadInitialData = async () => {
      if (!students || students.length === 0) {

        // You might want to dispatch an action to load students here
        // For now, we'll use the existing data from Redux
      }
      
      if (!schooldetails && admin?.schoolID) {

        // You might want to dispatch an action to load school details here
      }
    };
    
    loadInitialData();
  }, []);

  // Function to format date for display
  const formatDateForDisplay = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { 
      weekday: 'long', 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    });
  };

  // Enhanced date change handler with backend integration
  const handleDateChange = async (newDate) => {
    setSelectedDate(newDate);
    
    // Fetch canteen status for the new date
    try {
      await fetchCanteenStatus(newDate);
    } catch (error) {
      console.error('Error fetching canteen status:', error);
    }
  };

  // Fetch canteen status for a specific date
  const fetchCanteenStatus = async (date) => {
    try {
      // Since getCanteenStatus endpoint doesn't exist, use getStudentsWithCanteen
      // and create a mock status response for now
      const students = await canteenService.getStudentsWithCanteen(
        schooldetails?.schoolID || 'default',
        'Active'
      );

      // Create a mock status response based on students data
      const mockStatus = {
        success: true,
        date: date,
        totalStudents: students?.length || 0,
        paidStudents: 0, // TODO: Calculate from actual data
        unpaidStudents: students?.length || 0,
        totalAmount: 0, // TODO: Calculate from actual data
        results: []
      };

      setCanteenStatus(mockStatus);

    } catch (error) {
      console.error('Error fetching canteen status:', error);
      // Don't show error message for missing endpoint - it's expected
      // setmessage("Error fetching canteen status");
      // setstated("error");
      // setOpensnack(true);
      
      // Set empty status instead
      setCanteenStatus({
        success: false,
        date: date,
        totalStudents: 0,
        paidStudents: 0,
        unpaidStudents: 0,
        totalAmount: 0,
        results: []
      });
    }
  };

  // Setup canteen fees for selected class and date
  const handleSetupFees = async () => {
    if (!selectedClass || !inputAmount || !selectedDate) {
      setmessage("Please select class, amount, and date");
      setstated("warning");
      setOpensnack(true);
      return;
    }

    setSetupLoading(true);
    try {
      const data = await canteenService.setupCanteenFees(
        schooldetails?.schoolID || 'default',
        selectedClass,
        inputAmount,
        selectedDate,
        `Daily canteen fee for ${selectedClass}`,
        'admin'
      );

      if (data.success) {
        setmessage(`Canteen fees setup for ${data.studentsAffected} students`);
        setstated("success");
        setOpensnack(true);
        
        // Refresh canteen status
        await fetchCanteenStatus(selectedDate);
        
        // Clear inputs
        setInputAmount('');
        setSelected([]);
      }
    } catch (error) {
      console.error('Error setting up canteen fees:', error);
      setmessage("Error setting up canteen fees");
      setstated("error");
      setOpensnack(true);
    } finally {
      setSetupLoading(false);
    }
  };

  // Enhanced payment handler with backend integration
  const handlePayment = async () => {


    if (selected.length === 0) {
      setOpenAlert(true);
      return;
    }

    // Check if we have valid amounts for selected students
    const hasValidAmounts = selected.some(studentId => {
      const amount = studentAmounts[studentId] || inputAmount;
      return amount && amount > 0;
    });
    
    if (!hasValidAmounts) {
      setmessage("Please enter valid amounts for selected students or use 'Apply Amount' button");
      setstated("warning");
      setOpensnack(true);
      return;
    }

    if (!schooldetails?.schoolID) {
      setmessage("School ID not found. Please refresh the page.");
      setstated("error");
      setOpensnack(true);
      return;
    }

    if (!students || students.length === 0) {
      setmessage("No students data available. Please refresh the page.");
      setstated("error");
      setOpensnack(true);
      return;
    }

    setloading(true);

    try {
      // Prepare payment data for backend
      const paymentData = selected.map((mongoId, index) => {
        const student = students.find(s => s._id === mongoId);
        
        if (!student) {
          console.error(`❌ Student not found for MongoDB ID: ${mongoId}`);
          return null;
        }
        

        
        // Get the individual amount for this student, fallback to global inputAmount
        const studentAmount = studentAmounts[mongoId] || inputAmount;
        
        if (!studentAmount || studentAmount <= 0) {
          console.error(`❌ No valid amount for student: ${student.lastname} ${student.othernames}`);
          return null;
        }
        
        return {
          id: mongoId, // Using the MongoDB ObjectId directly (unique for each student)
          data: {
            canteen: {
              date: selectedDate,
              amount: parseFloat(studentAmount),
              description: `Canteen fee payment for ${selectedDate}`,
              status: 'Paid',
              addedBy: 'admin',
              timestamp: Date.now(),
              paymentMethod: 'cash'
            }
          }
        };
      }).filter(Boolean); // Remove any null entries

      const data = await canteenService.processPayments(
        paymentData,
        schooldetails?.schoolID || 'default',
        'Active'
      );

      // Handle successful response
      if (data && (data.success || data.length > 0)) {
        const successMessage = data.message || `Successfully processed ${paymentData.length} payments`;
        setmessage(successMessage);
        setstated("success");
        setOpensnack(true);
        
        // Update Redux store locally with new canteen data (no backend fetch needed)
        dispatch(updateCanteenPayments({
          paymentData: paymentData,
          selectedDate: selectedDate
        }));
        
        // Clear selection and amount
        setSelected([]);
        setInputAmount('');
        
        // Refresh canteen status (this will use updated Redux data)
        await fetchCanteenStatus(selectedDate);
        
      } else {
        setmessage("Error processing payments - invalid response from server");
        setstated("error");
        setOpensnack(true);
      }
    } catch (error) {
      console.error('🚨 Payment processing failed:', error);
      console.error('🚨 Error details:', {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
        config: error.config?.url,
        details: error.details
      });
      
      // Enhanced error messaging with better error handling
      let errorMessage = "Error processing payments";
      
      // Check if it's our enhanced error object
      if (error.message && error.details) {
        errorMessage = error.message;
        console.error('🚨 Enhanced error details:', error.details);
      } else if (error.message.includes('Server is not running')) {
        errorMessage = "Local server is not running. Please start the server first.";
      } else if (error.response?.status === 500) {
        errorMessage = "Server error. Please check server logs.";
      } else if (error.response?.status === 404) {
        errorMessage = "Payment endpoint not found. Please check server configuration.";
      } else if (error.message.includes('Network Error')) {
        errorMessage = "Network error. Please check your connection and server status.";
      } else if (error.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        errorMessage = error.message;
      }
      
      setmessage(errorMessage);
      setstated("error");
      setOpensnack(true);
    } finally {
      setloading(false);
    }
  };

  // Enhanced amount application handler
  const handleApplyAmount = () => {
    if (selected.length === 0) {
      setOpenAlert(true);
      return;
    }

    if (!inputAmount || inputAmount <= 0) {
      setmessage("Please enter a valid amount");
      setstated("warning");
      setOpensnack(true);
      return;
    }


    // Create temporary amounts object for selected students
    const tempAmounts = {};
    selected.forEach(studentId => {
      tempAmounts[studentId] = inputAmount;
    });

    // Store amounts in local state for table display
    setStudentAmounts(prev => ({
      ...prev,
      ...tempAmounts
    }));
    
    setmessage(`Amount ${currencySymbol} ${inputAmount} applied to ${selected.length} students`);
    setstated("success");
    setOpensnack(true);
    
  };

  const handleAmountChange = (studentId, value) => {
    
    // Update the student amounts in local state
    setStudentAmounts(prev => ({
      ...prev,
      [studentId]: value
    }));
  };


  const handleCloseAlert = (event, reason) => {
    if (reason === 'clickaway') return;
    setOpenAlert(false);
  };


  const handleClicksnack = () => {
    setOpensnack(true);
};


const handleClosesnack = (event, reason) => {
    if (reason === 'clickaway') {
        return;
    }

    setOpensnack(false);
};

const paymentlist=()=>{
var total=0
  for(var i in students){
    for (var k in students[i].canteen){
      total+=parseFloat(students[i].canteen[k].amount)
    }
  }
return total
}

  // Enhanced payment status function using backend data
  const getPaymentStatusForDate = (student, date) => {
    if (!student.canteen || student.canteen.length === 0) {
      return { status: 'Unpaid', amount: 0, paidDate: null };
    }
    
    const paymentForDate = student.canteen.find(payment => payment.date === date);
    if (paymentForDate) {
      return { 
        status: paymentForDate.status || 'Paid', 
        amount: paymentForDate.amount, 
        paidDate: paymentForDate.paymentDate || paymentForDate.date,
        receiptNumber: paymentForDate.receiptNumber
      };
    }
    
    return { status: 'Unpaid', amount: 0, paidDate: null };
  };

  // Fetch canteen status when component mounts or date/class changes
  useEffect(() => {
    if (selectedDate) {
      fetchCanteenStatus(selectedDate);
    }
  }, [selectedDate, selectedClass]);

  // Enhanced Redux data extraction with better error handling (already done above)
  // const admin = useSelector((state) => state.admin);
  // const stud = useSelector((state) => state.students);
  // const Class_ = useSelector((state) => state.class);
  // const schooldetails = useSelector((state) => state.schooldetails);

  // Remove duplicate student processing - we already have students from Redux above
  // const schools = stud || [];
  // const data = [schools.map((list, index) => createData(...))];
  // const students_ = data[0] || [];
  // const [students, setStudents] = useState(students_);
  
  // Use setStudents for updating the students state if needed
  const [studentsState, setStudents] = useState([]);

  // Enhanced filtered students with better performance
  const filteredStudents = React.useMemo(() => {
    if (!students || students.length === 0) return [];
    return students.filter(
      (student) =>
        ((student.lastname && student.lastname.toLowerCase().includes(filter.toLowerCase())) ||
         (student.othernames && student.othernames.toLowerCase().includes(filter.toLowerCase())) ||
          student.ID.toString().includes(filter)) &&
        (selectedClass === '' || student.class_ === selectedClass)
    );
  }, [students, filter, selectedClass]);

  // Enhanced canteen statistics calculation
  const canteenStats = React.useMemo(() => {
    if (!filteredStudents.length) return null;

    const totalStudents = filteredStudents.length;
    const paidStudents = filteredStudents.filter(student => {
      const status = getPaymentStatusForDate(student, selectedDate);
      return status.status === 'Paid';
    }).length;
    
    const unpaidStudents = totalStudents - paidStudents;
    const totalAmount = filteredStudents.reduce((total, student) => {
      const status = getPaymentStatusForDate(student, selectedDate);
      return total + (status.status === 'Paid' ? parseFloat(status.amount) : 0);
    }, 0);
    
    const expectedAmountPerStudent = inputAmount ? parseFloat(inputAmount) : 5.00;
    const expectedTotal = totalStudents * expectedAmountPerStudent;
    const outstandingBalance = Math.max(0, expectedTotal - totalAmount);
    const collectionRate = totalStudents > 0 ? Math.round((paidStudents / totalStudents) * 100) : 0;
    const averagePayment = paidStudents > 0 ? (totalAmount / paidStudents) : 0;
    const pendingAmount = unpaidStudents * expectedAmountPerStudent;

    return {
      totalStudents,
      paidStudents,
      unpaidStudents,
      totalAmount,
      expectedTotal,
      outstandingBalance,
      collectionRate,
      averagePayment,
      pendingAmount,
      expectedAmountPerStudent
    };
  }, [filteredStudents, selectedDate, inputAmount]);

  const handleSelect = (studentId) => {
    setSelected((prevSelected) =>
      prevSelected.includes(studentId)
        ? prevSelected.filter((id) => id !== studentId)
        : [...prevSelected, studentId]
    );
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      // Use MongoDB ObjectId (_id) for selection, not student.id
      setSelected(students.map((student) => student._id));
    } else {
      setSelected([]);
    }
  };

  return (
    <Box sx={{ width: '100%' }}>

       <Snackbar open={opensnack} autoHideDuration={6000} onClose={handleClosesnack}>
                      <Alert onClose={handleClosesnack} severity={stated} sx={{ width: '100%' }}>
                          { message }
                      </Alert>
                  </Snackbar>
            <Paper sx={{ width: '100%', mb: 2 }}>

<div style={{padding:"20px"}}>
    <p style={{textAlign:"center", fontWeight:"bolder"}}>CANTEEN FEES</p>
    <Divider/>
</div>

{/* Single Comprehensive Dashboard Card */}

    <div style={{ display: 'flex', alignItems: 'center', gap: '20px', marginBottom: '10px', padding:"10px", flexWrap: 'wrap' }}>
       
        <TextField
          label="Search Students"
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
          variant="outlined"
          size="small"
        />

        <FormControl variant="outlined" size="small" style={{ minWidth: '150px' }}>
          <InputLabel>Class</InputLabel>
          <Select
            value={selectedClass}
            onChange={(e) => setSelectedClass(e.target.value)}
            label="Class"
          >
            <MenuItem value="">All</MenuItem>
         
          {Class_ && Array.isArray(Class_) && Class_.length !== 0 ? 
            Class_.map((list, index) => (
              <MenuItem key={index} value={list.classname}>
                {list.classname}
              </MenuItem>
            )) : 
            <MenuItem disabled>No classes available</MenuItem>
          }
         
         </Select>
        </FormControl>

        <TextField
        label="Select Date"
        type="date"
        value={selectedDate}
        onChange={(e) => handleDateChange(e.target.value)}
        variant="outlined"
        size="small"
        InputLabelProps={{
          shrink: true,
        }}
        style={{ minWidth: '150px' }}
      />

        <TextField
          label="Set Amount for Selected Students"
          value={inputAmount}
          size='small'
          onChange={(e) => setInputAmount(e.target.value)}
          type="number"
          inputProps={{ min: 0, step: 0.01 }}
        />

        <Button
          variant="contained"
          color="secondary"
          onClick={handleSetupFees}
          disabled={setupLoading || !selectedClass || !inputAmount || !selectedDate}
          startIcon={setupLoading ? <CircularProgress size={20} color="inherit" /> : null}
        >
          {setupLoading ? 'Setting Up...' : 'Setup Fees'}
        </Button>

        <Button
          variant="contained"
          color="primary"
          onClick={handleApplyAmount}
          disabled={selected.length === 0 || !inputAmount}
        >
          Apply Amount
        </Button> 
        
        <Button
          variant="contained"
          color="success"
          onClick={handlePayment}
          disabled={loading || selected.length === 0 || !inputAmount}
          startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
        >
         {loading ? 'Processing...' : 'Submit Payment'}
        </Button>
      </div>

      {/* Enhanced Payment Summary for Selected Date */}
      <div style={{ 
        padding: '20px', 
        margin: '10px 0', 
        backgroundColor: '#f8f9fa', 
        borderRadius: '8px',
        border: '1px solid #e9ecef'
      }}>
        <Typography variant="h6" style={{ marginBottom: '15px', color: '#1976d2' }}>
          Payment Summary for {formatDateForDisplay(selectedDate)}
          {canteenStatus && (
            <span style={{ fontSize: '14px', color: '#666', marginLeft: '10px' }}>
              (Last updated: {new Date().toLocaleTimeString()})
            </span>
          )}
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={3}>
            <Paper elevation={1} style={{ padding: '15px', textAlign: 'center' }}>
              <Typography variant="h4" style={{ color: '#1a7f37', fontWeight: 'bold' }}>
                {canteenStats ? canteenStats.paidStudents : 
                  filteredStudents.filter(student => {
                    const status = getPaymentStatusForDate(student, selectedDate);
                    return status.status === 'Paid';
                  }).length}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Students Paid
              </Typography>
            </Paper>
          </Grid>
          <Grid item xs={12} sm={3}>
            <Paper elevation={1} style={{ padding: '15px', textAlign: 'center' }}>
              <Typography variant="h4" style={{ color: '#d14343', fontWeight: 'bold' }}>
                {canteenStats ? canteenStats.unpaidStudents : 
                  filteredStudents.filter(student => {
                    const status = getPaymentStatusForDate(student, selectedDate);
                    return status.status === 'Unpaid';
                  }).length}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Students Unpaid
              </Typography>
            </Paper>
          </Grid>
          <Grid item xs={12} sm={3}>
            <Paper elevation={1} style={{ padding: '15px', textAlign: 'center' }}>
              <Typography variant="h4" style={{ color: '#1976d2', fontWeight: 'bold' }}>
                {currencySymbol} {canteenStats ? canteenStats.totalAmount.toFixed(2) : 
                  filteredStudents.reduce((total, student) => {
                    const status = getPaymentStatusForDate(student, selectedDate);
                    return total + (status.status === 'Paid' ? parseFloat(status.amount) : 0);
                  }, 0).toFixed(2)}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Total Collected
              </Typography>
            </Paper>
          </Grid>
          <Grid item xs={12} sm={3}>
            <Paper elevation={1} style={{ padding: '15px', textAlign: 'center' }}>
              <Typography variant="h4" style={{ color: '#856404', fontWeight: 'bold' }}>
                {canteenStats ? canteenStats.totalStudents : filteredStudents.length}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Total Students
              </Typography>
            </Paper>
          </Grid>
        </Grid>
      </div>

  

      {/* Quick Actions for Unpaid Students */}
      <div style={{ 
        padding: '15px 20px', 
        margin: '10px 0', 
        backgroundColor: '#fff3cd', 
        borderRadius: '8px',
        border: '1px solid #ffeaa7'
      }}>
        <Typography variant="subtitle1" style={{ marginBottom: '10px', color: '#856404', fontWeight: '500' }}>
          Quick Actions
        </Typography>
        <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', alignItems: 'center' }}>
          <span style={{ fontSize: '14px', color: '#856404' }}>
            Unpaid students: {canteenStats ? canteenStats.unpaidStudents : 
              filteredStudents.filter(student => {
                const status = getPaymentStatusForDate(student, selectedDate);
                return status.status === 'Unpaid';
              }).length}
          </span>
          <Button
            variant="outlined"
            size="small"
            color="warning"
            onClick={() => {
              const unpaidStudents = filteredStudents.filter(student => {
                const status = getPaymentStatusForDate(student, selectedDate);
                return status.status === 'Unpaid';
              });
              setSelected(unpaidStudents.map(s => s._id));
            }}
          >
            Select All Unpaid
          </Button>
          <Button
            variant="outlined"
            size="small"
            color="success"
            onClick={() => {
              const paidStudents = filteredStudents.filter(student => {
                const status = getPaymentStatusForDate(student, selectedDate);
                return status.status === 'Paid';
              });
              setSelected(paidStudents.map(s => s._id));
            }}
          >
            Select All Paid
          </Button>
          <Button
            variant="outlined"
            size="small"
            color="info"
            onClick={() => {
              setSelected([]);
              setInputAmount('');
            }}
          >
            Clear Selection
          </Button>
          <Button
            variant="outlined"
            size="small"
            color="secondary"
            onClick={() => fetchCanteenStatus(selectedDate)}
          >
            Refresh Status
          </Button>
        </div>
      </div>

      <StudentTable
        students={filteredStudents}
        selected={selected}
        handleSelect={handleSelect}
        handleAmountChange={handleAmountChange}
        handleSelectAll={handleSelectAll}
        handlePayment={handlePayment}
        selectedDate={selectedDate}
        getPaymentStatusForDate={getPaymentStatusForDate}
        canteenStatus={canteenStatus}
        studentAmounts={studentAmounts}
        currencySymbol={currencySymbol}
      />

      <Snackbar
        open={openAlert}
        autoHideDuration={3000}
        onClose={handleCloseAlert}
      >
        <Alert onClose={handleCloseAlert} severity="warning" sx={{ width: '100%' }}>
          Please select at least one student to apply the amount.
        </Alert>
      </Snackbar>



    </Paper>
     
    </Box>
  );
}

export default App;
